import { store } from 'Store';
import { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { http } from "Utils/http";
import { Tab, Row, Card, Tabs, Col } from "react-bootstrap";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import AltProdBatchInProgress from './AltProdBatchInProgress';
import AltProdBatchCompleted from './AltProdBatchCompleted';
import AltFileUpload from 'Components/FileUpload/AltFileUpload';

const AltProdDataSubmission = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;
  const passedData = location.state;
  // state
  const [initData, setInitData] = useState();
  const [progress, setProgress] = useState();
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [tab, setTab] = useState(passedData?.tabKey ? passedData.tabKey : "inProgress");
  // set file type
  const fileFormat = ".xml, .zip, .csv";


  // refresh in-progress datable call back function 
  // if file upload successfully
  const refreshDataTable = (flag) => {
    //console.log("print out fileUploadOutputMsg", msg);
    setRefreshFlag(flag);
  }

  // init load ajax call
  const initLoad = async () => {
    var url = "/api/alt/initLoad";
    /** DO NOT REMOVE!!!
     * match AltBatchRequest.java
     * {
        paginationRequest;
        // Test: "Y", Prod: "N"
        isTestSubmission;
        }
     */
    var formData = {
      paginationRequest: null,
      isTestSubmission: "N"
    }

    return http.post(url, formData, {
      headers: {
        "Authorization": token
      }
    });
  }

  // set file upload ajax call
  const submitFile = async (formData) => {

    var url = '/api/alt/dataSubmission';

    return http.post(url, formData, {
      maxContentLength: 10000000,
      maxBodyLength: 10000000,
      timeout: 35000, // Set a timeout of 5 seconds
      headers: {
        "Authorization": token
      },
      onUploadProgress: data => {
        //Set the progress value to show the progress bar
        setProgress(Math.round((100 * data.loaded) / data.total))
      }
    });
  }

  useEffect(() => {
    initLoad().then((res) => {
      //console.log("Alt Init load", res);
      if (res !== null && res !== undefined) {
        var statusCode = res.status;
        if (statusCode < 0) {
          if (res.globalErrorMessageList && res.globalErrorMessageList.length != 0) {
            setGlobalErrorStatus({
              dispatch: dispatch,
              popupData: {
                visible: true,
                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                msg: res?.globalErrorMessageList,
                showContactHelp: true
              },
              redirect: {
                redirect: false,
                redirectFirst: false,
                path: "",
                data: {}
              }
            })
          }
        }
        setInitData(res.data);
      }
    }).catch((error) => {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }, [])

  // clear location state after "Back" for Tab switch
  useEffect(() => {
    location.state = null;
  }, [tab])

  return (
    <>
      <Row>
        <Col>
          <Card className="p-4">
            <Card.Body className="text-start">
              {initData?.psoppcAdmin && initData.psoppcAdmin === true ?
                null :
                <>
                  <p className="text-start">To submit production data, enter the required information below. The uploaded file name extensions should be in .xml, .csv or .zip format.</p>
                  <AltFileUpload
                    initData={initData}
                    isTestSubmission={"N"}
                    submitFile={submitFile}
                    fileFormat={fileFormat}
                    refreshDataTable={refreshDataTable}
                    progress={progress}
                    setProgress={setProgress}
                  />
                </>
              }
              <Row>
                <h2 className="text-start form-title">Production Data Submission Tables</h2>
                <p className="text-start ">Click on the tabs below to view each of the production data submission tables</p>
              </Row>
              <Tabs
                id="controlled-tab"
                activeKey={tab}
                onSelect={(k) => setTab(k)}
              >
                <Tab eventKey="inProgress" title={"In-Process Submissions"}>
                  {tab === "inProgress"
                    ?
                    <AltProdBatchInProgress refresh={refreshFlag}
                      isPSOPPCAdmin={initData?.psoppcAdmin && initData.psoppcAdmin === true}
                      isVendorLevel3={initData?.vendorUser && initData.vendorUser === true}
                    />
                    : ""
                  }
                </Tab>
                <Tab eventKey="completed" title={"Processed Submissions"}>
                  {tab === "completed"
                    ?
                    <AltProdBatchCompleted
                      isPSOPPCAdmin={initData?.psoppcAdmin && initData.psoppcAdmin === true}
                      isVendorLevel3={initData?.vendorUser && initData.vendorUser === true}
                    />
                    : ""
                  }
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default AltProdDataSubmission;